(ns client-portal.client.voice-insights.locations.data
  (:require [shared.core.reactive :as re]
            [client-portal.client.voice-insights.data :as vi.d]
            [client-portal.client.concepts.data :as concepts.d]
            [shared.core.router :as router]
            [shared.core.util :as util]
            [shared.core.time :as time]
            [client-portal.client.router :as cp.router]))

(def root-path [:voice-insights :locations])
(def list-path (conj root-path :list))
(def count-path (conj root-path :count))
(def filter-data-path (conj root-path :filter-data))
(def filter-container-height-path (conj root-path :filter-container-height))

(def default-filter-pair
  {:by "store-id"
   :condition "<"
   :value nil})

(defn locations-list-path [{:keys [concept-id]}]
  (conj list-path concept-id))

(defn filter-data [db]
  (let [fd (get-in db filter-data-path)]
    (if (empty? fd)
      [default-filter-pair]
      fd)))

(defn find-valid-filters [filters]
  (filter #(and (:by %) (:condition %) (seq (:value %))) filters))

(defn populate-default-filter-if-empty [filters]
  (if (empty? filters)
    [default-filter-pair]
    filters))

(re/reg-auth0-loader
 :locations/load-list-data
 (fn [[[_ args]]]
   (locations-list-path args))
 (fn [db [_ args]]
   {:method :post
    :url "/api/vi/locations/list"
    :json-params (vi.d/base-query-args db args)})
 :transf (fn [resp] (or (some->> resp :body (util/->kebab-case-keywords))
                        []))
 :error-transf (fn [] []))

(re/reg-auth0-load-sub
 :locations/list-
 (fn [_ args]
   (locations-list-path args))
 :locations/load-list-data)

(re/reg-event-db
 :locations/reload-locations-list re/middleware
 (fn [db]
   (-> db
       (assoc-in list-path nil))))

(re/reg-event-db
 :locations/initialize-filters re/middleware
 (fn [db]
   (-> db
       (assoc-in filter-data-path (populate-default-filter-if-empty (vi.d/filter-data-from-route db)))
       (assoc-in list-path nil))))

(re/reg-event-db
 :locations/add-filter-pair re/middleware
 (fn [db]
   (assoc-in db filter-data-path (vec (conj (filter-data db) default-filter-pair)))))

(re/reg-event-db
 :locations/remove-filter-pair re/middleware
 (fn [db [index]]
   (let [current-filters (filter-data db)
         updated-filters (vec (concat (take index current-filters)
                                      (drop (inc index) current-filters)))]
     (assoc-in db filter-data-path (populate-default-filter-if-empty updated-filters)))))

(re/reg-event-db
 :locations/update-filter-pair re/middleware
 (fn [db [index by value]]
   (assoc-in db filter-data-path (vec (update (filter-data db) index #(assoc % by value))))))

(defn filters->query-param [filters]
  (let [valid-filters (filter #(and (:by %) (:condition %) (seq (:value %)))
                              filters)
        valid-filters (when (not-empty valid-filters)
                        valid-filters)]
    (some-> valid-filters
            (util/map->json-string)
            (util/base-64-encode))))

(re/reg-event-db
 :locations/apply-filters re/middleware
 (fn [db]
   (let [cur-fd (:fd (router/current-query-params db))
         new-fd (filters->query-param (filter-data db))]
     (when (not= cur-fd new-fd)
       (re/dispatch [:router/go-with-merged-query-params
                     {:fd new-fd}])
       (re/dispatch [:locations/reload-conversations-list]))
     db)))

(re/reg-event-db
 :locations/clear-filters re/middleware
 (fn [db]
   (re/dispatch [:router/go-with-merged-query-params {:fd nil}])
   (-> (assoc-in db list-path nil)
       (assoc-in count-path nil)
       (assoc-in filter-data-path [default-filter-pair]))))

(re/reg-event-db
 :locations/delete-filter-data-index re/middleware
 (fn [db [index]]
   (let []
     (assoc-in db filter-data-path (populate-default-filter-if-empty (util/vec-remove (filter-data db) index))))))

(re/reg-sub :locations/filter-data- filter-data)

(re/reg-sub
 :locations/valid-filter-data-
 :<- [:locations/filter-data-]
 (fn [filters]
   (find-valid-filters filters)))

(re/reg-event-db
 :locations/close-filter-popover re/middleware
 (fn [db]
   (some-> (js/document.getElementById "locations-filter-tooltip")
           (.-_tippy)
           (.hide))
   db))

(re/reg-sub
 :locations/filter-container-height-
 (fn [db]
   (get-in db filter-container-height-path)))

(re/reg-event-db
 :locations/set-filter-container-height re/middleware
 (fn [db [h]]
   (assoc-in db filter-container-height-path h)))
